import { render, staticRenderFns } from "./QuickConfig.vue?vue&type=template&id=2305e3d2&scoped=true"
import script from "./QuickConfig.vue?vue&type=script&lang=js"
export * from "./QuickConfig.vue?vue&type=script&lang=js"
import style0 from "./QuickConfig.vue?vue&type=style&index=0&id=2305e3d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2305e3d2",
  null
  
)

export default component.exports